import { defineComponent, computed } from "vue";
import { useReviewsStore } from "./customerReviewsStore";
import EmptyStarImage from "../../assets/stars/emptyStar.png";
import FullStarImage from "../../assets/stars/fullStar.png";
export default defineComponent({
    name: "Comments",
    components: {},
    setup() {
        const store = useReviewsStore();
        const comments = computed(() => {
            const currentPageComments = store.pages[store.currentPage];
            currentPageComments.forEach((comment) => {
                comment.date = formatDate(comment.date);
                const dealerResponse = comment.dealerResponse;
                if (dealerResponse) {
                    dealerResponse.date = formatDate(dealerResponse.date);
                }
                const numberFullStars = parseInt(comment.rating);
                comment.starOneImagePath =
                    numberFullStars >= 1 ? FullStarImage : EmptyStarImage;
                comment.starTwoImagePath =
                    numberFullStars >= 2 ? FullStarImage : EmptyStarImage;
                comment.starThreeImagePath =
                    numberFullStars >= 3 ? FullStarImage : EmptyStarImage;
                comment.starFourImagePath =
                    numberFullStars >= 4 ? FullStarImage : EmptyStarImage;
                comment.starFiveImagePath =
                    numberFullStars >= 5 ? FullStarImage : EmptyStarImage;
            });
            return currentPageComments;
        });
        const dealerName = store.dealerName;
        const numberOfPages = computed(() => store.pages.length - 1);
        const currentPage = computed(() => store.currentPage);
        const hasNavigationButtons = computed(() => numberOfPages.value ? numberOfPages.value > 1 : false);
        const previousButtonDisabled = computed(() => currentPage.value ? currentPage.value == 1 : true);
        const nextButtonDisabled = computed(() => currentPage.value ? currentPage.value == numberOfPages.value : true);
        function formatDate(date) {
            const formattedDate = date
                .split("-")
                .map((n) => {
                return parseInt(n);
            })
                .join("/");
            return formattedDate;
        }
        function changePage(e, buttonType) {
            buttonType == "previous" ? store.previousPage() : store.nextPage();
            var scrollDiv = document.getElementById("reviewComments").offsetTop - 200;
            window.scrollTo({ top: scrollDiv, behavior: "smooth" });
        }
        return {
            comments,
            dealerName,
            hasNavigationButtons,
            previousButtonDisabled,
            nextButtonDisabled,
            changePage,
        };
    },
});
